import React, { FC, useState } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { addressRegex, emailReg, LocalNumberRegex, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import  Datepicker  from "../../generic/Datepicker";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import usePositionHook from "../../../hooks/usePositionHook";
import { contractTypes, wageTypes } from "../../../constant/data";
import { onAddContract, onAddContractDoc } from "../../../services/contract";
import DocumentUpload from "../../forms/DocumentUpload";
import { usePhotoUpload } from "../../../hooks/usePhotoUploadhook";
import useFilePicker from "../../../hooks/useFilePicker";
import { FiPlusCircle } from "react-icons/fi";
import { onUploadDoc } from "../../../services/document";

export default (props: any) => {
  var { control, handleSubmit, watch } = useForm();

  const startdatepick = usePickerhook();
  const enddatepick = usePickerhook();
  const positionPickhook = usePickerhook();
  const contracttypePickhook = usePickerhook();
  const wagetypePickhook = usePickerhook();
  const employeepickHook = usePickerhook();
  const departmentPickhook = usePickerhook();
  const { selectedOrgDepts } = useDepartmentHook();
  const fileuploadhook = useFilePicker();
  const [documents, setdocument] = useState<any[]>([]);
  const { allorgPositions } = usePositionHook();
  const { setLoading } = useStateSetter();
  const watchedFields = watch(["title", "wage"]);
  const { selectedOrgEmployees } = useEmployeeHook();
  const { SelectedOrg, config, authuser } = useStateGetter();
  const { UserOrgs } = useOrganizationHook();
  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined &&
      departmentPickhook.pickedRole &&
      positionPickhook.pickedRole &&
      contracttypePickhook.pickedRole &&
      startdatepick.pickedRole &&
      enddatepick.pickedRole &&
      wagetypePickhook.pickedRole &&
      employeepickHook.pickedRole
  );
  const onSubmit = async (data: any) => {
    console.log(data);

    var Postdata = {
      title: data.title,
      type: contracttypePickhook.pickedRole.name,
      startDate: startdatepick.pickedRole.name,
      endDate: enddatepick.pickedRole.name,
      wageType: wagetypePickhook.pickedRole.name,
      wage: parseInt( data.wage.replace(/,/g, '')),
      status: "running",
      employeeID: employeepickHook.pickedRole.code,
      organizationID: SelectedOrg.id,
      deptID: departmentPickhook.pickedRole.code,
      positionID: positionPickhook.pickedRole.code,
      createdBy: authuser.id,
    };

    setLoading(true);
    try {
      var response = await onAddContract(Postdata, config);

      if (response.success) {
        toast.success(response.message);

        if (documents.length>0) {
          var form = new FormData();
          form.append("document", documents[0]);
          var docuploadres = await onUploadDoc(form, config);
          if (docuploadres.success) {
            toast.success(docuploadres.message);

            var contractdocpostdata = {
              contractID: response.data.id,
              documentURL: docuploadres.data,
              status: "active",
            };

            var finalresponse = await onAddContractDoc(
              contractdocpostdata,
              config
            );
            toast(finalresponse.message);
          }
        }

        props.show(false);
       props. refresh()
      }

      setLoading(false);
    } catch (e: any) {
      console.log(e);
      toast.error(e);
      props.show(false);

      //props.show(false);
    }

    setLoading(false);
  };
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col  max-h-[80vh] overflow-y-scroll  rounded-[8px] bg-white w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm ">New contract</p>
          <InputField
            name="title"
            title="Contract title"
            placeholder={"Contract title"}
            control={control}
            rules={{
              required: "Contract titleis required",
              pattern: {
                value: addressRegex,
                message: "Invalid Contract title",
              },
            }}
          />
          <div className=" grid grid-cols-2 gap-4  	 ">
            <ListPicker
              fullwidth
              hook={employeepickHook}
              title="Employee"
              list={selectedOrgEmployees.map((i: any) => {
                return { name: `${i.firstName} ${i.lastName} `, code: i.id };
              })}
            />
            <ListPicker
              fullwidth
              hook={contracttypePickhook}
              title="Contract Type"
              list={contractTypes}
            />

            <ListPicker
              fullwidth
              hook={positionPickhook}
              title="Position"
              list={allorgPositions.map((i: any) => {
                return { name: i.positionTitle, code: i.id };
              })}
            />
            <ListPicker
              fullwidth
              hook={departmentPickhook}
              title="Department"
              list={selectedOrgDepts.map((i) => {
                return { name: i.deptName, code: i.id };
              })}
            />

            <Datepicker
              defaultvalue={{
                code: new Date(),
                name: new Date().toDateString(),
              }}
              hook={startdatepick}
              title="Start date"
            />

            <Datepicker
              defaultvalue={{ code: new Date(), name: new Date().toDateString }}
              hook={enddatepick}
              title="End date"
            />

            <ListPicker
              fullwidth
              hook={wagetypePickhook}
              title="Wage Type"
              list={wageTypes}
            />

            <InputField
              name="wage"
              title="Wage"
              placeholder={"Wage"}
              control={control}
              rules={{
                required: "wage is required",
                pattern: {
                  value: LocalNumberRegex,
                  message: "Invalid wage",
                },
              }}
            />
          </div>
          <div>
            <p className="text flex font-semibold text-gray-600 gap-4  my-3 text-xs">
              Documents{" "}
              <FiPlusCircle className={"inline text-primary"} size={20} />{" "}
              <span
                onClick={() => {
                  setdocument((prev) => prev.concat([""]));
                }}
                className="text-primary cursor-pointer text"
              >
                Add
              </span>
            </p>
            {documents.map((i: any, key) => (
              <DocumentUpload files_={documents} file={i} setfiles ={setdocument} key_={key} />
            ))}
          </div>
          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text="Add Contract"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
